import {FC} from 'react';
import {Typography} from 'components/Typography';
import {useSanitizeString} from 'core/hooks/useSanitizeString';
import {ShieldMobile} from 'modules/events/components/ShieldMobile';
import style from './style.module.scss';
import {useRouter} from 'next/router';
import {useGetEventQuery} from 'modules/events/services';

export const EventXDescription: FC = () => {
    const {query} = useRouter();
    const {data} = useGetEventQuery({id: query.slug as string});
    const event = data?.data;

    if (!event?.previewDescription) {
        return null;
    }

    return (
        <div className={`${style.root}`}>
            <EventTitle />
            <EventShield drinkType={event.drinkType} />
            <EventDescriptionText description={event.previewDescription} />
        </div>
    );
};

const EventTitle: FC = () => (
    <Typography element={'div'} variant={'price-20-b'}>
        О мероприятии
    </Typography>
);

interface IEventShieldProps {
    drinkType: {
        code?: string;
        title?: string;
    };
}

const EventShield: FC<IEventShieldProps> = ({drinkType}) => {
    if (!drinkType?.code || !drinkType?.title || 'mix' === drinkType?.code) {
        return null;
    }

    return (
        <div className={style.shieldsContainer}>
            <ShieldMobile src={`/images/shields/${drinkType.code}.svg`} title={drinkType.title} />
        </div>
    );
};

interface IEventDescriptionTextProps {
    description: string;
}

const EventDescriptionText: FC<IEventDescriptionTextProps> = ({description}) => {
    const sanitizedDescription = useSanitizeString(description);

    return (
        <Typography element={'div'} variant={'body-16-r'}>
            {/* eslint-disable-next-line @typescript-eslint/naming-convention */}
            <span dangerouslySetInnerHTML={{__html: sanitizedDescription}} />
        </Typography>
    );
};
